<div class="share-conversation-container">
    <button (click)="shareConversation()" class="button primary t-bottom t-no-arrow"  [attr.data-tooltip]="'SHARE_CONVERSATION_BUTTON_TOOLTIP' | translate" [attr.aria-label]="'SHARE_CONVERSATION_BUTTON_TOOLTIP' | translate">
        <img *ngIf = "isAgent"src="../../../assets/images/icon-share.svg" alt="Share" class="share-icon">
        <img  *ngIf = "!isAgent" src="../../../assets/icons/share.svg" alt="Share" class="share-icon share-icon-not-agent">
    </button>
</div>

